export const environment = {
  production: true,

  // Remote Pythonanywhere
  APIurl: "https://escolalms.pythonanywhere.com",

  // DJRS
  // APIurl: "http://192.168.147.98:8000",

};
